import { createSelector } from '@reduxjs/toolkit'

import { STATUS_NO_REVIEW_REQUIRED, STATUS_REVIEWED } from '../constants'
import { isValidNumber } from '../helpers/numbers'

const getPropertyIncomeSummary = (state) => state.propertyIncomeSummary
const getPropertyIncomes = (state) => state.propertyIncomes
const getPropertyIncomesItems = (state) => state.propertyIncomes.items
const pluckPropertyIncomeId = (_state, { id }) => id

export const getPropertyIncomeById = createSelector(
    [getPropertyIncomesItems, pluckPropertyIncomeId],
    (propertyIncomes, propertyIncomeId) =>
        propertyIncomes.find((propertyIncome) => propertyIncome.id === propertyIncomeId)
)

const getAreAllPropertyIncomeItemsReviewed = createSelector([getPropertyIncomesItems], (propertyIncomesItems) =>
    propertyIncomesItems.every(({ reviewStatus }) =>
        [STATUS_NO_REVIEW_REQUIRED, STATUS_REVIEWED].includes(reviewStatus)
    )
)

export default createSelector(
    [getPropertyIncomeSummary, getPropertyIncomes, getPropertyIncomesItems, getAreAllPropertyIncomeItemsReviewed],
    (propertyIncomeSummary, propertyIncomes, propertyIncomesItems, areAllPropertyIncomeItemsReviewed) => {
        const {
            fetchSuccessful: isFetchSuccessfulPropertyIncomeSummary,
            shouldFetch: shouldFetchPropertyIncomeSummary,
        } = propertyIncomeSummary

        const {
            fetchSuccessful: isFetchSuccessfulPropertyIncomes,
            shouldFetch: shouldFetchPropertyIncomes,
            items,
        } = propertyIncomes

        const propertiesWithIncome = items.filter(
            ({ income, reviewStatus }) => isValidNumber(income) && reviewStatus !== STATUS_NO_REVIEW_REQUIRED
        )
        const propertiesWithoutIncome = items.filter(
            ({ income, reviewStatus }) => !isValidNumber(income) || reviewStatus === STATUS_NO_REVIEW_REQUIRED
        )

        return {
            areAllPropertyIncomeItemsReviewed,
            hasPropertyIncomeSummary: !!propertyIncomeSummary.taxReturnId,
            isFetchSuccessfulPropertyIncomeSummary,
            isFetchSuccessfulPropertyIncomes,
            propertiesWithoutIncome,
            propertyIncomeSummary,
            propertyIncomeSummaryStatus: propertyIncomeSummary.status,
            propertyIncomes,
            propertyIncomesItems,
            propertiesWithIncome,
            shouldFetchPropertyIncomeSummary,
            shouldFetchPropertyIncomes,
        }
    }
)
